import { ConfigT } from "../config-io";
import fetchApi from "../fetch-api";
import * as t from "io-ts";

const updateConfigCodec = t.type({
		acknowledged: t.boolean,
		modifiedCount: t.number,
		upsertedId: t.union([t.null, t.string]),
		upsertedCount: t.number,
		matchedCount: t.number
})

export const saveConfig = (props: ConfigT) => {
  const {companyID } = props;	
  return fetchApi({
    service: "admin-service",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    pathname: `/update-configuration?companyID=${companyID}`,
    codec:updateConfigCodec,
    body: props,
  });
};